<article class="mt-3">

  <div class="d-flex justify-content-evenly">
    <div class="box-acoes">
      <app-botao-primario (onPress)="mostraInputExcluir()" titulo="Excluir Roteiro"
        [disabled]="roteiro.IdRoteiroSituacao != 1 || roteiro.roteiroLimpo || showInput || showInputFinalizar"
        imagemBtn="assets/img/icons/close.svg"></app-botao-primario>
    </div>

    <div class="box-acoes">
      <app-botao-primario (onPress)="mostraInputFinalizar()" titulo="Finalizar Roteiro"
        [disabled]="roteiro.IdRoteiroSituacao == 5 || showInput || showInputFinalizar" imagemBtn="assets/img/icons/icon-status-finalizado-green.svg">
      </app-botao-primario>
    </div>
  </div>

  <div class="m-4 mb-0" *ngIf="showInput">
    <input title="Confirme o número do roteiro" class="form-control mt-1 mb-2" type="text" placeholder="Confirme o roteiro"
      [(ngModel)]="chaveValidacao" />
    <div class="d-flex justify-content-between">
      <app-texto-link titulo="Cancelar" (click)="mostraInputExcluir()" class="ms-4"></app-texto-link>
      <app-botao-primario (onPress)="confirmarExclusaoRoteiro()" titulo="Confirmar"
        [disabled]="chaveValidacao != numeroRoteiro"></app-botao-primario>
    </div>
  </div>

  <div class="m-4 mb-0" *ngIf="showInputFinalizar">
    <span class="text-danger font-weight-bold">Ao encerrar o roteiro, o motorista será automaticamente desconectado do
      aplicativo e os pedidos pendentes serão marcados como entregues.</span>
    <input class="form-control mt-1 mb-2" type="text" placeholder="Informe o número do roteiro para confirmar a ação"
      [(ngModel)]="chaveValidacao" />

    <div class="d-flex justify-content-between align-items-center">
      <app-texto-link titulo="Cancelar" (click)="esconderInputFinalizar()" class="ms-4"></app-texto-link>

      <div class="d-flex align-items-center">
        <i class="fa fa-spinner fa-spin me-3" style="color: #03a886; font-size: 1.5rem;" *ngIf="loadingFinalizar"></i>
        <app-botao-primario (onPress)="finalizarRoteiro()" [titulo]="loadingFinalizar ? 'Aguarde...' : 'Confirmar'"
          [disabled]="chaveValidacao != numeroRoteiro || loadingFinalizar"> </app-botao-primario>
      </div>
    </div>
  </div>

</article>